import React, { Component } from 'react'
import Icons from '~/Common-Objects/UI/Icons/index'
import Toggle from '~/Common-Objects/UI/Forms/Toggle/Toggle'
import { connect } from 'react-redux';
import i18n from '~/i18n';

@connect((store) => {
    return { user: store.user }
})

export default class ComponentToggle extends Component {
    constructor(props) {
        super(props)
        this.change = this.change.bind(this);
        this.state = {

        }
    }


    change(event) {
        let newVal = event.currentTarget.checked + "";
        this.props.updateVal(this.props.path, newVal);
    }

    render() {

        let finalValue = false;
        if (this.props.value + "" == "true") finalValue = true;
        if (this.props.value + "" == "false") finalValue = false;
        if (this.props.value + "" == "1") finalValue = true;
        if (this.props.value + "" == "0") finalValue = false;

        let outerClass = "dndEditorv2-dd_toolHolder";
        if (this.props.elementData.optionHalfWidth) outerClass += " dndEditorv2-dd_toolHolder-half";
        return <div className={outerClass}>
            <div className="dd_inputTool" style={{ display: "flex", gap: "5px" }}>

                <Toggle
                    label={""}
                    before={""}
                    after={this.props.title}
                    checked={finalValue}
                    name="doNotTrackLinks"
                    onChange={this.change}
                >
                </Toggle>

                {this.props.elementData.toolTip && <Icons
                    icon='questionCircle'
                    className='mar-l5'
                    style={{ width: 16, height: 16, cursor: 'pointer' }}
                    data-tooltip-content={this.props.elementData.toolTip}
                    data-tooltip-id="toggle-tooltip"
                    data-tooltip-style={{ maxWidth: "200px", zIndex: 99999 }}
                    data-tooltip-position="right"
                />}
            </div>
        </div>


    }
}


